function generateAction(type, payload) {
    return {
        type,
        payload
    }
}

export { generateAction }